import React,  { useState } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal'; 

const Link = styled.div`
  font-size: 12px;
  width: 100%;
  text-align: right;
  padding: 10px 10px 0 0;
  text-decoration: underline;
  color:  #666;
  cursor: pointer;
`;

const CloseIcon = styled.i`
  cursor: pointer;
  position: absolute;
  top: 18px;
  right: 22px;
  font-size: 18px;
  color: #6d7f99;

  &:hover {
    color: var(--primary-color);
  }
`;

const modalStyles = {
  overlay: {
    zIndex: 99999,
    backgroundColor: 'rgba(24, 39, 58, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  content: {
    position: 'relative',
    inset: 'auto',
    width: 'min(860px, calc(100vw - 48px))',
    maxHeight: 'calc(100vh - 48px)',
    overflow: 'auto',
    border: 'none',
    borderRadius: '6px',
    padding: '0',
    boxShadow: '0 18px 50px rgba(0, 0, 0, 0.25)',
    background: '#ffffff',
  },
};

const MoreInfoPopUp = ({ label, info, children }) => {
  const [infoVisible, setInfoVisible] = useState(false);

  return (
    <div>
      <Link onClick={() => setInfoVisible(!infoVisible)}>
        { infoVisible ? 'Ocultar' : label }
      </Link>
      {
        infoVisible && (
          <Modal
            ariaHideApp={false}
            isOpen={infoVisible}
            onRequestClose={() => setInfoVisible(false)}
            style={modalStyles}
          >
            <CloseIcon className="fas fa-times" onClick={() => setInfoVisible(false)} />
            { info }
        </Modal>
        )
      }
    </div>
  );
};

export default MoreInfoPopUp;
